<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left">Daily Report Detail</h5>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col sm="3">
                <label class="mr-sm-2" for="reportingDate">Reporting Date (YYYY/MM/DD)</label>
                <b-input id="reportingDate" type="date" placeholder="" v-model.trim="reportingDate" :max="maxDate" :state="$v.reportingDate.$error?false:null" @blur.native="$v.reportingDate.$touch"></b-input>
                <div v-if="$v.reportingDate.$error">
                  <div class="invalid-feedback d-block" v-if="!$v.reportingDate.required">Reporting Date is required</div>
                </div>
              </b-col>
              <b-col sm="4" class="align-self-end">
                <b-button id="sBtn" variant="primary" @click="getReportFiles" :disabled="$v.reportingDate.$invalid">Search</b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left">Report Files</h3>
          </b-card-header>
          <b-card-body>
            <b-table responsive="sm" :items="items" :fields="fields" :busy="fetching">
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(index)="data">
                {{ data.index+1 }}
              </template>
              <template v-slot:cell(action)="data">
                <a :href="data.item.Url" download>
                  <b-button variant="primary"><i class="icons fa fa-download"></i></b-button>
                </a>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  import moment from 'moment-timezone'
  const {required} = require('vuelidate/lib/validators')

  export default {
    name: 'daily-report-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        maxDate: moment().tz('Asia/Taipei').subtract({ days: 1 }).format('YYYY-MM-DD'),
        reportingDate: moment().tz('Asia/Taipei').subtract({ days: 1 }).format('YYYY-MM-DD'),
        fetching: false,
        items: [],
        fields: [
          {key: 'index', label: 'S.No'},
          {key: 'CategoryType', label: 'Category Type'},
          {key: 'ReportingDate', label: 'Reporting Date'},
          {key: 'Created_at', label: 'Created Time'},
          {key: 'action', label: 'Action'}
        ]
      }
    },
    validations: {
      reportingDate: {
        required
      }
    },
    methods: {
      async getReportFiles () {
        try {
          this.fetching = true
          const reportingDate = this.reportingDate
          let queryStr = `?reportingDate=${reportingDate}`
          const { data: { list } } = await this.$http.get(`${this.API_ENDPOINT}/report/dailyReport/getList` + queryStr, { headers: { 'Content-Type': 'application/json' } })
          this.items = list
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        } finally {
          setTimeout(() => {
            this.fetching = false
          }, 200)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/report/member/DailyReportDetailTable.vue